import { UTCTimestamp, Time, BusinessDay } from 'lightweight-charts'

export function toUTCTimestamp(time: Time | undefined): UTCTimestamp | undefined {
  if (time === undefined) return undefined
  if (typeof time === 'number') {
    return time as UTCTimestamp
  }
  if (typeof time === 'string') {
    return (new Date(time + 'T00:00:00Z').getTime() / 1000) as UTCTimestamp
  }
  const { year, month, day } = time as BusinessDay
  return (Date.UTC(year, month - 1, day) / 1000) as UTCTimestamp
}